import TableCell from "@material-ui/core/TableCell";
import React from "react";
import './TagsCell.css';
import Tags from "./tags/Tags";

const TagsCell = (props) => {
    return (
        <TableCell>
            <Tags tags={props.tags}/>
        </TableCell>
    )
}
export default TagsCell;
